import type { GridRowId, GridRowModel, GridRowSelectionModel } from '@mui/x-data-grid';

export function emptySelection(): GridRowSelectionModel {
  return { type: 'include', ids: new Set() };
}

export function selectedRowIds(selection: GridRowSelectionModel, rows: GridRowModel[]): GridRowId[] {
  return selection.type === 'include'
    ? Array.from(selection.ids)
    : rows.map(({ id }) => id).filter((id) => !selection.ids.has(id));
}
